module.exports = __webpack_public_path__ + "static/img/Door_Sliding.286821c.jpg";